function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 12C4 7.03 8.03 3 13 3C17.97 3 22 7.03 22 12C22 16.97 17.97 21 13 21C10.51 21 8.27 19.99 6.64 18.36L8.06 16.94C9.32 18.21 11.07 19 13 19C16.87 19 20 15.87 20 12C20 8.13 16.87 5 13 5C9.13 5 6 8.13 6 12H9L5 15.99L1 12H4ZM12 13V8H13.5V12.15L17.02 14.24L16.25 15.52L12 13Z",
  fill: "#685DA8"
});

var SvgIcHistoric = function SvgIcHistoric(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcHistoric, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-historic.4c0e03f0.svg";
export { ForwardRef as ReactComponent };